import { render, staticRenderFns } from "./BaseAvatarContactCardComponent.html?vue&type=template&id=1a495e82&"
import script from "./BaseAvatarContactCardComponent.js?vue&type=script&lang=js&"
export * from "./BaseAvatarContactCardComponent.js?vue&type=script&lang=js&"
import style0 from "./BaseAvatarContactCardComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports